import Beta from "../../../../contents/docs/workflows/_snippets/beta.mdx";
import CalloutBox from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  Beta,
  CalloutBox,
  React
};